import { Cidade, error99, Estado, Parceiro, ParceiroAttributes, RetAPI } from "../../Utils/Types"
import { Api } from "../../Utils/api"
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const ParceiroService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {
        const resp = await Api('Parceiro/attributes', 'get', { id })
        const attributes: ParceiroAttributes = {
            estados: [],
            cidades: [],
            parceiros: {
                id: 0,
                id_user_insert: 0,
                id_user_last_update: 0,
                dt_cadastro: '',
                dt_last_update: '',
                razao: '',
                nome_fantasia: '',
                endereco: '',
                bairro: '',
                cep: '',
                id_cidade: 0,
                tipo_pessoa: '',
                cnpj_cpf: '',
                ie_rg: '',
                complemento: '',
                observacao: '',
                ativo: '',
                numero: '',
                telefone: '',
                celular: '',
                contato: '',
                email: '',
                nome_cidade: '',
                uf: '',
                name_user_insert: '',
                name_user_last_update: '',

                description: ''
            }
        }

        if (resp.data) {

            let estados: Estado[] = []
            let cidades: Cidade[] = []

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.estados) {
                    estados = resp.data.estados.map((estado: any) => {
                        return {
                            id: estado.id,
                            description: estado.nome,
                            sigla: estado.sigla,
                            codIBGE: estado.cod_ibge,
                        }
                    })
                    attributes.estados = estados
                }

                if (resp.data.cidades) {
                    cidades = resp.data.cidades.map((cidade: any) => {
                        return {
                            id: cidade.codigo,
                            description: cidade.nome,
                            uf: cidade.uf,
                            codIBGE: cidade.codigo,
                        }
                    })
                    attributes.cidades = cidades
                }

                if (resp.data.parceiro) {

                    attributes.parceiros.id = resp.data.parceiro.id
                    attributes.parceiros.id_user_insert = resp.data.parceiro.id_user_insert
                    attributes.parceiros.id_user_last_update = resp.data.parceiro.id_user_last_update
                    attributes.parceiros.dt_cadastro = resp.data.parceiro.dt_cadastro
                    attributes.parceiros.dt_last_update = resp.data.parceiro.dt_last_update
                    attributes.parceiros.razao = resp.data.parceiro.razao
                    attributes.parceiros.nome_fantasia = resp.data.parceiro.nome_fantasia
                    attributes.parceiros.endereco = resp.data.parceiro.endereco
                    attributes.parceiros.bairro = resp.data.parceiro.bairro
                    attributes.parceiros.cep = resp.data.parceiro.cep
                    attributes.parceiros.id_cidade = resp.data.parceiro.id_cidade
                    attributes.parceiros.tipo_pessoa = resp.data.parceiro.tipo_pessoa
                    attributes.parceiros.cnpj_cpf = resp.data.parceiro.cnpj_cpf
                    attributes.parceiros.ie_rg = resp.data.parceiro.ie_rg
                    attributes.parceiros.complemento = resp.data.parceiro.complemento
                    attributes.parceiros.observacao = resp.data.parceiro.observacao
                    attributes.parceiros.ativo = resp.data.parceiro.ativo
                    attributes.parceiros.numero = resp.data.parceiro.numero
                    attributes.parceiros.telefone = resp.data.parceiro.telefone
                    attributes.parceiros.celular = resp.data.parceiro.celular
                    attributes.parceiros.contato = resp.data.parceiro.contato
                    attributes.parceiros.email = resp.data.parceiro.email
                    attributes.parceiros.nome_cidade = resp.data.parceiro.nome_cidade
                    attributes.parceiros.uf = resp.data.parceiro.uf
                    attributes.parceiros.name_user_insert = resp.data.parceiro.name_user_insert
                    attributes.parceiros.name_user_last_update = resp.data.parceiro.name_user_last_update
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (parceiro: any): Promise<RetAPI> => {

        let id = ''

        if (parceiro.id) {
            id = parceiro.id.toString()
        }

        const params = {
            razao: parceiro.razao,
            nome_fantasia: parceiro.nome_fantasia,
            endereco: parceiro.endereco,
            bairro: parceiro.bairro,
            cep: parceiro.cep,
            id_cidade: parceiro.id_cidade,
            tipo_pessoa: parceiro.tipo_pessoa,
            cnpj_cpf: parceiro.cnpj_cpf,
            ie_rg: parceiro.ie_rg,
            complemento: parceiro.complemento,
            observacao: parceiro.observacao,
            ativo: parceiro.ativo,
            numero: parceiro.numero,
            celular: parceiro.celular,
            contato: parceiro.contato,
            telefone: parceiro.telefone,
            email: parceiro.email,
            id
        }

        const resp = await Api('Parceiro/save', 'post', params)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }

            }

            return {
                error: false,
                msg: "Dados do parceiro gravados com sucesso",
                id: resp.data.parceiro.id,
                data: resp.data,
                dt_cadastro: resp.data.parceiro.dt_cadastro,
                dt_last_update: resp.data.parceiro.dt_last_update,
                name_user_insert: resp.data.parceiro.name_user_insert,
                name_user_last_update: resp.data.parceiro.name_user_last_update,
            }


        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }
    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Parceiro/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('Parceiro/filter', 'get', { field, filter_type, filter, id })
        const parceiros: Parceiro[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: parceiros
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.parceiros.map((parceiro: any) => {
                    return parceiros.push({
                        id: parceiro.id,
                        razao: parceiro.razao,
                        nome_fantasia: parceiro.nome_fantasia,
                        endereco: parceiro.endereco,
                        bairro: parceiro.bairro,
                        cep: parceiro.cep,
                        id_cidade: parceiro.id_cidade,
                        idUF: parceiro.id_uf,
                        uf: parceiro.uf,
                        tipo_pessoa: parceiro.tipo_pessoa,
                        cnpj_cpf: parceiro.cnpj_cpf,
                        ie_rg: parceiro.ie_rg,
                        complemento: parceiro.complemento,
                        observacao: parceiro.observacao,
                        ativo: parceiro.ativo,
                        numero: parceiro.numero,
                        telefone: parceiro.telefone,
                        celular: parceiro.celular,
                        email: parceiro.email,
                        contato: parceiro.contato,
                        nome_cidade: parceiro.nome_cidade,
                        description: parceiro.razao
                    }) 
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: parceiros
            }
        }

        return {
            error: false,
            data: parceiros
        }

    },

}